import { render, staticRenderFns } from "./InlineCode.vue?vue&type=template&id=c5b978d0&"
import script from "./InlineCode.vue?vue&type=script&lang=js&"
export * from "./InlineCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports